// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3XD43","author":"Table_author__3EY7y","authorImage":"Table_authorImage__1UrwR","unreadRow":"Table_unreadRow__3l54R"};